import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppSettings {
  public appDarkMode: boolean = false;
  public appWithLoyaltyCard: boolean = false;
}
